var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 17V13H16",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8V11H11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5168 10.3329C18.2171 9.53646 17.7078 8.82439 17.0363 8.26314C16.3648 7.70189 15.5531 7.30975 14.6769 7.12331C13.8007 6.93686 12.8886 6.9622 12.0256 7.19695C11.1626 7.43169 10.3769 7.8682 9.74182 8.46574L7 10.8886M20 13.1114L17.2582 15.5343C16.6231 16.1318 15.8374 16.5683 14.9744 16.8031C14.1114 17.0378 13.1993 17.0631 12.3231 16.8767C11.4469 16.6903 10.6352 16.2981 9.96368 15.7369C9.29221 15.1756 8.78287 14.4635 8.48318 13.6671",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.7778C25 19.3671 24.7701 19.9324 24.361 20.3491C23.9518 20.7659 23.3968 21 22.8182 21H3.18182C2.60316 21 2.04821 20.7659 1.63904 20.3491C1.22987 19.9324 1 19.3671 1 18.7778V6.55556C1 5.96619 1.22987 5.40095 1.63904 4.98421C2.04821 4.56746 2.60316 4.33333 3.18182 4.33333H7.54545L9.72727 1H16.2727L18.4545 4.33333H22.8182C23.3968 4.33333 23.9518 4.56746 24.361 4.98421C24.7701 5.40095 25 5.96619 25 6.55556V18.7778Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipIcon);
export default __webpack_public_path__ + "static/media/flip-icon.7ba3832657e8af0f779c979fd2a3f43b.svg";
export { ForwardRef as ReactComponent };